var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraycoin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4946_736)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.00003 14.0001C10.6512 14.0001 13.6111 11.0402 13.6111 7.38894C13.6111 3.73773 10.6512 0.777832 7.00003 0.777832C3.34881 0.777832 0.388916 3.73773 0.388916 7.38894C0.388916 11.0402 3.34881 14.0001 7.00003 14.0001Z",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00003 13.2222C10.6512 13.2222 13.6111 10.2623 13.6111 6.61111C13.6111 2.9599 10.6512 0 7.00003 0C3.34881 0 0.388916 2.9599 0.388916 6.61111C0.388916 10.2623 3.34881 13.2222 7.00003 13.2222Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00011 12.4446C10.007 12.4446 12.4446 10.007 12.4446 7.00011C12.4446 3.99322 10.007 1.55566 7.00011 1.55566C3.99322 1.55566 1.55566 3.99322 1.55566 7.00011C1.55566 10.007 3.99322 12.4446 7.00011 12.4446Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00011 12.0554C10.007 12.0554 12.4446 9.61783 12.4446 6.61095C12.4446 3.60406 10.007 1.1665 7.00011 1.1665C3.99322 1.1665 1.55566 3.60406 1.55566 6.61095C1.55566 9.61783 3.99322 12.0554 7.00011 12.0554Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.38047 3.30245C7.57565 3.06837 7.95581 3.22834 7.92493 3.5316L7.7069 5.66187H9.47059C9.52927 5.66189 9.58673 5.67863 9.63624 5.71013C9.68575 5.74162 9.72526 5.78658 9.75015 5.83972C9.77503 5.89286 9.78426 5.95199 9.77676 6.01019C9.76925 6.06839 9.74532 6.12325 9.70776 6.16834L6.61953 9.87422C6.42435 10.1083 6.04419 9.94834 6.07507 9.64507L6.2931 7.51481H4.52941C4.47073 7.51478 4.41327 7.49804 4.36376 7.46655C4.31425 7.43505 4.27474 7.3901 4.24985 7.33695C4.22496 7.28381 4.21573 7.22468 4.22324 7.16648C4.23075 7.10828 4.25468 7.05342 4.29223 7.00834L7.38047 3.30245Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4946_736"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraycoin);
export default __webpack_public_path__ + "static/media/graycoin.49c6ae2916ed71603049dde572e4fb85.svg";
export { ForwardRef as ReactComponent };